import { render, staticRenderFns } from "./QuantitativeFashion.vue?vue&type=template&id=56c18670&scoped=true&"
import script from "./QuantitativeFashion.vue?vue&type=script&lang=js&"
export * from "./QuantitativeFashion.vue?vue&type=script&lang=js&"
import style0 from "./QuantitativeFashion.vue?vue&type=style&index=0&id=56c18670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c18670",
  null
  
)

export default component.exports